<!-- eslint-disable max-len -->
<template>
  <div>
    <Card title="Admin User Management">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <el-input placeholder="search user name" v-model="filter" @change="searchUser" ></el-input>
              </div>
              <Button @clicked="searchUser" label="Apply"/>
              <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="reset" /></button>
            </div>
            <Button @clicked="toggleModalAdd" label="Add Admin User" variant="outline-primary"/>
          </div>
        </div>
        <data-tables-server ref="tableUser" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [20] }" @query-change="onChangeTable" >
          <el-table-column type="selection" width="55">
          </el-table-column>

          <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
          </el-table-column>
          <el-table-column label="Actions" align="right" min-width="160px">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="Edit" :position="'is-left'">
                  <button @click="edit($event, scope.row)" class="p-2 w-8 mr-2 rounded bg-yellow-600 hover:bg-yellow-800 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip label="Delete" :position="'is-left'">
                  <button @click="deleteUser($event, scope.row)"  class="w-8 mr-2 p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialog
      ref="addUsersAdmin"
      :isShowingModal="isShowingModalAdd"
      :isLoading="isLoading"
      :isError="isError"
      title="Add Admin Users"
      :labelSubmit="'Add'"
      @toggleModal="toggleModalAdd()"
      @save="create" >
      <template slot="body" >
        <form class="flex w-full overflow-y-auto overflow-x-hidden" id="form-activity" autocomplete="off" >
          <div class="w-full" >
            <form-item label='Name'>
              <template v-slot>
                <Input
                  v-model="input.name"
                  placeholder="Name"
                  :error="$v.input.name.$dirty && (!$v.input.name.required || !$v.input.name.maxLength)"
                  maxlength="100"
                />
                <div class="flex flex-col pt-2">
                  <text-error v-if="$v.input.name.$dirty && !$v.input.name.required" text="Please fill Name." />
                  <text-error v-if="$v.input.name.$dirty && !$v.input.name.maxLength" text="Max length name is 100 character." />
                </div>
              </template>
            </form-item>
            <form-item label='Email'>
              <template v-slot>
                <Input
                  v-model="input.email"
                  placeholder="ex : john@example.com"
                  :error="$v.input.email.$dirty && (!$v.input.email.required || !$v.input.email.email)"
                />
                <div class="flex flex-col pt-2">
                  <text-error v-if="$v.input.email.$dirty && !$v.input.email.required" text="Please fill Email." />
                  <text-error v-if="$v.input.email.$dirty && !$v.input.email.email" text="Email is not valid." />
                </div>
              </template>
            </form-item>
            <form-item label='Role'>
              <template v-slot>
                <Select
                  v-model="input.role"
                  empty-label="Select Role"
                  :error="$v.input.role.$dirty && (!$v.input.role.required)"
                  :data="listRole"
                />
                <div class="flex flex-col pt-2">
                  <text-error v-if="$v.input.role.$dirty && !$v.input.role.required" text="Please select role." />
                </div>
              </template>
            </form-item>
          </div>
        </form>
      </template>
    </ModalDialog>
    <ModalDialog
      ref="editUsersAdmin"
      :isShowingModal="isShowingModalEdit"
      :isLoading="isLoading"
      :isError="isError"
      title="Edit Admin Users"
      :labelSubmit="'Update'"
      @toggleModal="toggleModalEdit()"
      @save="updates"
    >
      <template slot="body" >
        <form class="flex w-full overflow-y-auto overflow-x-hidden" id="form-activity" autocomplete="off" >
          <div class="w-full" >
            <form-item label='Name'>
              <template v-slot>
                <Input
                  v-model="update.name"
                  placeholder="Name"
                  :error="$v.update.name.$dirty && (!$v.update.name.required || !$v.update.name.maxLength)"
                  maxlength="100"
                />
                <div class="flex flex-col pt-2">
                  <text-error v-if="$v.update.name.$dirty && !$v.update.name.required" text="Please fill Name." />
                  <text-error v-if="$v.update.name.$dirty && !$v.update.name.maxLength" text="Max length name is 100 character." />
                </div>
              </template>
            </form-item>
            <form-item label='Email'>
              <template v-slot>
                <Input
                  v-model="update.email"
                  placeholder="ex : john@example.com"
                  :error="$v.update.email.$dirty && (!$v.update.email.required || !$v.update.email.email)"
                />
                <div class="flex flex-col pt-2">
                  <text-error v-if="$v.update.email.$dirty && !$v.update.email.required" text="Please fill Email." />
                  <text-error v-if="$v.update.email.$dirty && !$v.update.email.email" text="Email is not valid." />
                </div>
              </template>
            </form-item>
            <form-item label='Role'>
              <template v-slot>
                <Select
                  v-model="update.role"
                  empty-label="Select Role"
                  :error="$v.update.role.$dirty && (!$v.update.role.required)"
                  :data="listRole"
                />
                <div class="flex flex-col pt-2">
                  <text-error v-if="$v.update.role.$dirty && !$v.update.role.required" text="Please select role." />
                </div>
              </template>
            </form-item>
          </div>
        </form>
      </template>
    </ModalDialog>
  </div>
</template>
<script>
import Card from '@/components/Layout/Card';
import { FormItem, Input, Button, Select, TextError } from '@/components/Layout/Form';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ModalDialog from '../components/Common/ModalDialog';
import ModalDialogDetail from '../components/Common/ModalDialogDetail';
import { ViewProfile } from '../components/Profile';
import { validationMixin } from 'vuelidate';
import { required, email, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'UsersAdminPage',
  mixins: [validationMixin],
  data() {
    return {
      isLoading: false,
      isShowingModal: false,
      isShowingModalAdd: false,
      isShowingModalEdit: false,
      displayingItem: 20,
      isError: false,
      data: [],
      total: 0,
      page: 1,
      titles: [{
        prop: 'name',
        label: 'Name',
      }, {
        prop: 'email',
        label: 'Email',
      }, {
        prop: 'status',
        label: 'Status',
      }, {
        prop: 'roleText',
        label: 'Role',
      }],
      filter: '',
      selectedRow: [],
      user: {
        id: '',
        name: '',
        email: '',
        status: '',
      },
      input: {
        name: '',
        email: '',
        role: '',
      },
      update: {
        name: '',
        email: '',
        role: '',
        id: '',
      },
      listRole: [
        {
          value: 'admin',
          label: 'Administrator',
        },
        {
          value: 'operation',
          label: 'Operations and Media',
        },
        {
          value: 'review_committee',
          label: 'Music Review Committee',
        },
        {
          value: 'recruitment',
          label: 'Recruitment',
        },
        {
          value: 'finance',
          label: 'Finance',
        },
      ],
    };
  },
  validations() {
    let rule = {
      input: {
        name: {

        },
        email: {

        },
        role: {

        },
      },
      update: {
        name: {

        },
        email: {

        },
        role: {

        },
      },
    };

    if (this.isShowingModalAdd) {
      rule = Object.assign(rule, {
        input: {
          name: {
            required,
            maxLength: maxLength(100),
          },
          email: {
            required,
            email,
          },
          role: {
            required,
          },
        },
      });
    }

    if (this.isShowingModalEdit) {
      rule = Object.assign(rule, { update: {
        name: {
          required,
          maxLength: maxLength(100),
        },
        email: {
          required,
          email,
        },
        role: {
          required,
        },
      } });
    }

    return rule;
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListUser({ per_page: this.displayingItem });
    this.refineData();
  },
  computed: {
    ...mapGetters('UserModule', ['listUser', 'getUser']),
  },
  watch: {
    listUser: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
    getUser: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        let status = '';
        switch (val.status) {
          case 1:
            status = 'Active';
            break;
          case 2:
            status = 'Blocked';
            break;
          // eslint-disable-next-line no-fallthrough
          case 0:
          default:
            status = 'Pending';
            break;
        }
        this.user = Object.assign(this.user, val, { status });
      },
    },
  },
  methods: {
    ...mapActions('UserModule', ['requestListUser', 'requestDetailUser', 'requestDeleteUser',
      'requestBlockUser', 'requestUnblockUser', 'requestCreateUser', 'requestUpdateUser', 'requestDeleteUserByEmail']),
    async searchUser() {
      await this.requestListUser({ per_page: this.displayingItem, q: this.filter });
      this.refineData();
    },
    async reset() {
      this.$refs.tableUser.$refs.elTable.clearSort();
      this.filter = '';
      this.searchUser();
    },
    resetStateAdd() {
      this.$v.$reset();
      this.isError = false;
      this.input = Object.assign({}, {
        name: '',
        email: '',
        role: '',
      });
    },
    resetStateEdit() {
      this.$v.$reset();
      this.isError = false;
      this.update = Object.assign({}, {
        name: '',
        email: '',
        role: '',
        id: '',
      });
    },
    async detailUser(user) {
      await this.requestDetailUser(user.id);
      this.toggleModal();
    },
    toggleModal() {
      this.isShowingModal = !this.isShowingModal;
    },
    toggleModalAdd() {
      this.isShowingModalAdd = !this.isShowingModalAdd;
    },
    toggleModalEdit() {
      this.isShowingModalEdit = !this.isShowingModalEdit;
      this.resetStateEdit();
    },
    edit(event, row) {
      this.toggleModalEdit();
      this.update = Object.assign({}, {
        name: row.name,
        email: row.email,
        role: row.role,
        id: row.id,
      });
    },
    async create() {
      try {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const user = {
            name: this.input.name,
            email: this.input.email,
            role: this.input.role,
          };
          await this.requestCreateUser({ user, filter: { per_page: this.displayingItem, q: this.filter } });
          this.isShowingModalAdd = false;
          this.resetStateAdd();
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        this.isError = true;
      }
    },
    async updates() {
      try {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const user = {
            name: this.update.name,
            email: this.update.email,
            role: this.update.role,
            id: this.update.id,
          };
          await this.requestUpdateUser({ user, filter: { per_page: this.displayingItem, q: this.filter } });
          this.isShowingModalEdit = false;
          this.resetStateEdit();
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        this.isError = true;
      }
    },
    refineData() {
      if (this.listUser.data !== undefined) {
        this.total = this.listUser.data.total;
        const _this = this;
        this.data = this.listUser.data.data.map((user, index) => {
          let status = '';
          const statusCode = user.status;
          switch (user.status) {
            case 1:
              status = 'Active';
              break;
            case 2:
              status = 'Blocked';
              break;
            // eslint-disable-next-line no-fallthrough
            case 0:
            default:
              status = 'Pending';
              break;
          }
          let roleText = '';
          switch (user.role) {
            case 'admin':
              roleText = 'Administrator';
              break;
            case 'operation':
              roleText = 'Operations and Media';
              break;
            case 'review_committee':
              roleText = 'Music Review Committee';
              break;
            case 'recruitment':
              roleText = 'Recruitment';
              break;
            case 'finance':
              roleText = 'Finance';
              break;
            default:
              roleText = '-';
              break;
          }
          return Object.assign({}, user, { status, statusCode, seq: ((_this.page - 1) * _this.displayingItem) + index + 1, roleText });
        });
      }
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      this.page = page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      await this.requestListUser({ per_page: this.displayingItem, q: this.filter, sortorder, sortby, page });
    },
    async deleteUser(event, row) {
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete user: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          const email = row.email;
          await this.requestDeleteUserByEmail({ email, filter: { per_page: this.displayingItem, q: this.filter } });
          this.$swal('Deleted', `You successfully delete user: ${row.name}`, 'success');
        }
      });
    },
  },
  components: {
    ModalDialogDetail,
    ModalDialog,
    ViewProfile,
    Card,
    FormItem, Input, Button, Select, TextError,
  },
};
</script>
<style scoped>
.el-table{
  min-height: 400px;
}

</style>



// WEBPACK FOOTER //
// src/views/UsersAdmin.vue